import { isNil } from 'lodash';
import { HUE_SEGMENT_SIZE } from '@/color/constants/hueWheel';
import { degreeToRadian, normalizeAngle } from '@/color/types/Angle';
import { isFullHueRange } from '@/color/types/AngleRange';
// first element is 5R on client and 2.5 on backend
const FIRST_ELEMENT_OFFSET = HUE_SEGMENT_SIZE;
export function angleRangeToFilterValue(angleRange) {
    if (isFullHueRange(angleRange)) {
        return {
            from: null,
            to: null,
        };
    }
    return {
        from: normalizeAngle(angleRange.start + FIRST_ELEMENT_OFFSET),
        to: normalizeAngle(angleRange.end + FIRST_ELEMENT_OFFSET),
    };
}
export function filterValueToAngleRange(filterValue) {
    const { from, to } = filterValue;
    return {
        start: isNil(from) ? 0 : fromBackendToClientAngle(from),
        end: isNil(to) ? 360 : fromBackendToClientAngle(to),
    };
}
export function filterValueToApiFormat(filterValue) {
    const range = filterValueToAngleRange(filterValue);
    if (isFullHueRange(range)) {
        return {
            from: null,
            to: null,
        };
    }
    return {
        from: degreeToRadian(normalizeAngle(range.start + FIRST_ELEMENT_OFFSET)),
        to: degreeToRadian(normalizeAngle(range.end + FIRST_ELEMENT_OFFSET)),
    };
}
export function fromBackendToClientAngle(angle) {
    return normalizeAngle(angle - FIRST_ELEMENT_OFFSET);
}
